var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
import { environment } from 'environments/environment';
var PorcentajesComponent = /** @class */ (function () {
    function PorcentajesComponent(http, snackBar) {
        this.http = http;
        this.snackBar = snackBar;
        this.porcentajes = [];
        this.loading = false;
        this.editMode = false;
        // Formulario
        this.porcentajeForm = {
            tipo: 'aporte',
            porcentaje: 0.0255,
            titulo: '',
            descripcion: '',
            anio: new Date().getFullYear()
        };
    }
    PorcentajesComponent.prototype.ngOnInit = function () {
        this.cargarPorcentajes();
    };
    PorcentajesComponent.prototype.cargarPorcentajes = function () {
        var _this = this;
        this.loading = true;
        this.http.get(environment.backendUrl + "/api/porcentajes")
            .subscribe(function (data) {
            _this.porcentajes = data;
            _this.loading = false;
        }, function (error) {
            console.error('Error al cargar porcentajes:', error);
            _this.snackBar.open('Error al cargar los porcentajes', 'Cerrar', {
                duration: 3000
            });
            _this.loading = false;
        });
    };
    PorcentajesComponent.prototype.guardarPorcentaje = function () {
        var _this = this;
        if (!this.validarFormulario()) {
            return;
        }
        this.loading = true;
        if (this.editMode && this.porcentajeForm.id) {
            // Actualizar
            this.http.put(environment.backendUrl + "/api/porcentajes/" + this.porcentajeForm.id, this.porcentajeForm)
                .subscribe(function () {
                _this.snackBar.open('Porcentaje actualizado correctamente', 'Cerrar', {
                    duration: 3000
                });
                _this.cargarPorcentajes();
                _this.limpiarFormulario();
            }, function (error) {
                console.error('Error al actualizar:', error);
                _this.snackBar.open('Error al actualizar el porcentaje', 'Cerrar', {
                    duration: 3000
                });
                _this.loading = false;
            });
        }
        else {
            // Crear nuevo
            this.http.post(environment.backendUrl + "/api/porcentajes", this.porcentajeForm)
                .subscribe(function () {
                _this.snackBar.open('Porcentaje creado correctamente', 'Cerrar', {
                    duration: 3000
                });
                _this.cargarPorcentajes();
                _this.limpiarFormulario();
            }, function (error) {
                console.error('Error al crear:', error);
                _this.snackBar.open('Error al crear el porcentaje', 'Cerrar', {
                    duration: 3000
                });
                _this.loading = false;
            });
        }
    };
    PorcentajesComponent.prototype.editarPorcentaje = function (porcentaje) {
        this.editMode = true;
        this.porcentajeForm = __assign({}, porcentaje);
        window.scrollTo(0, 0);
    };
    PorcentajesComponent.prototype.eliminarPorcentaje = function (id) {
        var _this = this;
        if (!confirm('¿Está seguro de eliminar este porcentaje?')) {
            return;
        }
        this.loading = true;
        this.http.delete(environment.backendUrl + "/api/porcentajes/" + id)
            .subscribe(function () {
            _this.snackBar.open('Porcentaje eliminado correctamente', 'Cerrar', {
                duration: 3000
            });
            _this.cargarPorcentajes();
        }, function (error) {
            console.error('Error al eliminar:', error);
            _this.snackBar.open('Error al eliminar el porcentaje', 'Cerrar', {
                duration: 3000
            });
            _this.loading = false;
        });
    };
    PorcentajesComponent.prototype.limpiarFormulario = function () {
        this.editMode = false;
        this.porcentajeForm = {
            tipo: 'aporte',
            porcentaje: 0.0255,
            titulo: '',
            descripcion: '',
            anio: new Date().getFullYear()
        };
    };
    PorcentajesComponent.prototype.validarFormulario = function () {
        if (!this.porcentajeForm.titulo || this.porcentajeForm.titulo.trim() === '') {
            this.snackBar.open('El título es requerido', 'Cerrar', {
                duration: 3000
            });
            return false;
        }
        if (!this.porcentajeForm.tipo) {
            this.snackBar.open('El tipo es requerido', 'Cerrar', {
                duration: 3000
            });
            return false;
        }
        if (this.porcentajeForm.porcentaje === null || this.porcentajeForm.porcentaje === undefined) {
            this.snackBar.open('El porcentaje es requerido', 'Cerrar', {
                duration: 3000
            });
            return false;
        }
        if (this.porcentajeForm.porcentaje < 0 || this.porcentajeForm.porcentaje > 9.9999) {
            this.snackBar.open('El porcentaje debe estar entre 0 y 9.9999', 'Cerrar', {
                duration: 3000
            });
            return false;
        }
        if (!this.porcentajeForm.anio || this.porcentajeForm.anio < 2000 || this.porcentajeForm.anio > 2100) {
            this.snackBar.open('El año debe estar entre 2000 y 2100', 'Cerrar', {
                duration: 3000
            });
            return false;
        }
        return true;
    };
    PorcentajesComponent.prototype.formatearPorcentaje = function (porcentaje) {
        return (porcentaje * 100).toFixed(2) + '%';
    };
    PorcentajesComponent.prototype.getTipoLabel = function (tipo) {
        return tipo === 'aporte' ? 'Aporte' : 'Contribución';
    };
    PorcentajesComponent.prototype.getTipoBadgeClass = function (tipo) {
        return tipo === 'aporte' ? 'badge-primary' : 'badge-success';
    };
    return PorcentajesComponent;
}());
export { PorcentajesComponent };
